import { render, staticRenderFns } from "./CommunitiesCreate.vue?vue&type=template&id=625934ef"
import script from "./CommunitiesCreate.vue?vue&type=script&lang=js"
export * from "./CommunitiesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports